<ng-container *ngIf="!!get">
    <tt-input ttLabelView="top" ttLabel="p2_setting_keyno" [ttModel]="get.p2_setting_keyno" ttReadonly></tt-input>
    <tt-input ttLabelView="top" ttLabel="word_id" [(ttModel)]="get.word_id"></tt-input>
    <tt-input ttLabelView="top" ttLabel="setting_name" [ttModel]="get.setting_name" ttReadonly [ttButtons]="get.p2_setting_keyno > '0' ? settingNameButtons : []"></tt-input>
    <tt-input ttLabelView="top" ttLabel="input_type" [(ttModel)]="get.input_type"></tt-input>
    <tt-input ttLabelView="top" ttLabel="default_value" [(ttModel)]="get.default_value"></tt-input>
    <tt-input ttLabelView="top" ttLabel="choicedata" [(ttModel)]="get.choicedata"></tt-input>
    <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
</ng-container>

<ng-container *ngIf="!get">
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <ng-container *ngTemplateOutlet="inputskeleton"></ng-container>
    <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); background-color: var(--tt-success-color); margin-bottom: 7px"></div>
</ng-container>

<ng-template #inputskeleton>
    <div class="col-xs-4 sp-0 tt-skeleton" style="width: 40%; height: var(--tt-font-size-sm); margin-bottom: 4px"></div>
    <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
</ng-template>
